// loader-interceptor.service.ts
import { Injectable } from '@angular/core';
import {
    HttpResponse,
    HttpRequest,
    HttpHandler,
    HttpEvent,
    HttpInterceptor
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { OverlayManagerService } from './overlay-manager.service';
import { catchError, map } from 'rxjs/operators';

@Injectable()
export class LoaderInterceptor implements HttpInterceptor {
    exceptionURLs = ['/v1/smartscapeversion', '/getRecentMessages', '/controllerDetails', 'controllerlist', 'getWeatherForecast', 'notifications', 'getFirmwareUpdateInfo', 'setdefaulttheme', 'status', '/imageassets/getImage', 'includeSceneScheduleSummary', 'activeControllers', 'runningstatus', 'controllerstatus', '/getLpcus'];

    constructor(
        private overlayManager: OverlayManagerService
    ) { }

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        if (!this.isURLExists(request.url, this.exceptionURLs)) {
            let isSpinnerStartedFromHere = false;
            if (!this.overlayManager.isProcessing) {
                this.overlayManager.showProcessingOverlay.next('Loading...');
                isSpinnerStartedFromHere = true;
            }


            return next.handle(request)
                .pipe(map<HttpEvent<any>, any>((evt: HttpEvent<any>) => {
                    if (evt instanceof HttpResponse) {
                        if (isSpinnerStartedFromHere) {
                            this.overlayManager.hideProcessingOverlay.next(false);
                        }

                    }
                    return evt;
                }))
                .pipe(catchError((err) => {
                    if (isSpinnerStartedFromHere) {
                        this.overlayManager.hideProcessingOverlay.next(false);

                    }

                    throw err;
                }));
        } else {
            return next.handle(request);
        }

    }

    isURLExists(url, array) {
        return array.some(e => url.includes(e));
    }

}
